import React from "react";

import { Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";

import BaseButton from "../../common/BaseButton";
import heroArcImg from '../../../assets/images/heroArc.png';
import heroTopArcImg from '../../../assets/images/heroTopArc.png';
import heroArcImgMobile from '../../../assets/images/heroArcMobile.png';
import PropTypes from "prop-types";
import { ReactComponent as ScrollSvg } from '../../../assets/images/scroll.svg';

import './style.scss'; 

function HeroSection ({title, description, icon, hasBtn = true, isTopArc = false}) {
    let navigate = useNavigate();

    const handleScroll = () => {
        const { innerHeight: windowHeight } = window;
        const headerHeight = document.getElementsByClassName("header")[0].clientHeight;
        window.scrollTo(0, windowHeight - headerHeight)
    }

    return (
        <Row className="hero-section">
            <Col xs={12} md={6}>
                <h1 className="heading-1">{title}</h1>
                <img className="hero-img-mobile" src={icon} alt="hero"/>
                <p className="body-text-big">{description}</p>
                {hasBtn
                    ? <BaseButton onClick={() => navigate('/contacts')}/>
                    : <></>
                }
                
            </Col>
            <Col xs={12} md={6}>
                <img className="hero-img" src={icon} alt="hero"/>
            </Col>
            {isTopArc
                //TODO: once we have heroTopArcImg place it here
                ? <img src={heroTopArcImg} className="hero-top-arc" alt="hero top arc"/>
                // ? <></>
                : <img src={heroArcImg} className="hero-arc" alt="hero arc"/>
            }
            
            <img src={heroArcImgMobile} className="hero-arc-mobile" alt="hero arc"/>
            <div className="scroll-btn">
                <div className="scroll-wrapper">
                    <ScrollSvg  
                        onClick={handleScroll}
                    />
                </div>
                
            </div>
        </Row>
    )
}

HeroSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default HeroSection;
